import React, { Component } from 'react';
import { connect } from 'react-redux';
import TranslatedCopy from '../../intl/translated-copy';
import LoadingComponent from './loading-component';

const mapStateToProps = state => ({
  storefront : state.Manage.storefront,
  language: state.Manage.language,
});

class SearchModal extends Component {
  constructor() {
    super();

    this.state = {
      inputValue: '',
      isLoading: true,
      animation: false,
    };

    this.handleClearClick = this.handleClearClick.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleFocus = this.handleFocus.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
  }

  componentDidMount() {
    const { inputValueSearchModal } = this.props;
    const closeSearchModal = (inputValueSearchModal) => {
      if (inputValueSearchModal) {
        this.setState({ inputValue: '' });
      }
    };
    closeSearchModal(inputValueSearchModal);
    setTimeout(() => {
      this.setState({ animation: true });
    }, 200);
  }

  componentWillUnmount() {
    this.handleAnimation();
  }

  render() {
    const { modalSearchClose } = this.props;
    const { animation, isLoading } = this.state;
    return (
      <div className='Modal'>
        <div className={`Modal-inner Modal-inner--SEARCH_MODAL ${modalSearchClose ? 'Modal-inner--SEARCH_MODAL_CLOSE' : null}`}>
          <div className={`Modal-body Modal-body--SEARCH_MODAL Modal--SEARCH_ANIMATION ${ animation && 'Modal-body--isOpen'} is-fullScreen`}>
            <div className='Modal-content Modal-content--SEARCH_MODAL'>
              <div className='SearchModal'>
                { this.renderTopBar() }
                { !isLoading ? <LoadingComponent /> : this.renderBody() }
              </div>
            </div> 
          </div> 
        </div> 
      </div>
    );
  }

  handleAnimation = () => {
    this.setState({ animation: false });
  }

  renderTopBar() {
    return (
      <div className='ModalSearch-topBar'>
        <button
          className='Modal-close Icon Icon--xThin'
          onClick={ () => this.props.handleCloseSearchModal() } 
        />
      </div>
    );
  }

  renderBody() {
    return (
      <div className='Grid Grid--content'>
        <div className='Grid-col u-colSm6 u-colMd-12 u-colMdHigh-10 u-offsetMdHigh-1 u-colLg-8 u-offsetLg-2'>
          <TranslatedCopy
            tagName='h2'
            copyID='APP_SEARCH'
            className='SearchHeader-searchHeaderLabel' />
          { this.renderInput() }
        </div>
      </div>
    );
  }

  renderInput() {
    const {
      helperTraslatedCopy,
      storefront,
    } = this.props;

    const pathName = window.location.origin;
    const { inputValue } = this.state;
    const isInputEmpty = inputValue.length === 0;
    const placeholder = helperTraslatedCopy.getFormatMessageFromcopyId('APP_NEED_HELP_SEARCH');
    return (
      <div className='SearchHeader-inputPlaceholder'>
        <div className='SearchHeader-inputWrapper'>
          <div className='SearchHeader-inputContentWrapper'>
            <div className='SearchHeader-inputContent'>
              <form
                onSubmit={ (e) => (e.preventDefault())}
                ref={c => this.form = c}
                id='ModalSearch-inputField'
                className='SearchHeader-inputField'>
                <input
                  className='st-default-search-input SearchHeader-searchInput'
                  ref={ (c) => this.input = c }
                  value={inputValue}
                  onChange={ this.handleChange }
                  onFocus={ this.handleFocus }
                  onBlur={ this.handleBlur }
                  onKeyPress={ this.handleKeyPress }
                  placeholder={ placeholder }
                  type='search'/>
                <ul className='search_autocomplete' id='search_autocomplete' />
              </form>
              <div className='SearchHeader-buttons'>
                { !isInputEmpty && (
                  <div
                    className='SearchHeader-clearButton Icon Icon--x'
                    onClick={ this.handleClearClick }
                    role='button'/>
                )}
                <a 
                  href={`${ pathName }/${ storefront }/${this.searchLanguage()}#?cludoquery=${ inputValue }`}
                  className='SearchHeader-searchButton Icon Icon--search'
                  target='_blank'
                  rel='noopener noreferrer'
                  id='searchInput'
                ></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  searchLanguage() {
    const { language } = this.props;

    let sfSearch = '';

    switch (language) {
      case 'en':
        sfSearch = 'search';
        break;
      case 'es':
        sfSearch = 'buscar';
        break;
      case 'fr':
        sfSearch = 'rechercher';
        break;
      case 'pt':
        sfSearch = 'pesquisa';
        break;
      default:
        sfSearch = '';
    }

    return sfSearch;
  }

  handleChange(e) {
    this.setState({
      inputValue: e.target.value,
    });
  }

  handleFocus(e) {
    this.setState({
      inputValue: e.target.value,
    });
  }

  handleBlur(e) {
    this.setState({
      inputValue: e.target.value,
    });
  }

  handleKeyPress(e) {
    const anchor = document.querySelector('#searchInput');
    if (e.key === 'Enter') {
      anchor.click();
    }
  }

  handleClearClick() {
    this.setState({ inputValue: '' });
  }
}

SearchModal = connect(mapStateToProps)(SearchModal);

export default SearchModal;
